import SimpleHeader from '../../components/layout/SimpleHeader';
import ExtendButton from '../../components/ExtendButton';
import Footer from '../../components/layout/Footer';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import SelectCampus from '../../components/SelectCampus';
import Button from '../../components/Button';
import { Empty, Select, Table, TableColumnsType } from 'antd';
import Pagination from '../../components/Pagination';
import useAxios from '../../hooks/useAxios';
import { IClassList, IGetClasses } from '../../models/campusClasses.model';
import { getClasses } from '../../api/campusClasses.api';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/rootReducer';
import { getCurrentSemester, getCurrentSemesterByType } from '../../api/semesters.api';
import { ICurrentSemester, IGetCurrentSemester } from '../../models/semesters.model';
import { getCommonCodeLabel } from '../../lib/store';
import {
  useCancelBookLoanMutation,
  useLazyGetAvailableLoanableBooksQuery,
  useLazyGetBookLoanDuplicateQuery,
  useLazyGetStudentBookLoanHistoryQuery,
  useLazyGetStudentByCampusClassQuery,
  useSaveBookLoanMutation,
} from '../../api/books/bookManagement.api';
import { infoVariant, successVariant } from '../../lib/barVariant';
import { useSnackbar } from 'notistack';
import moment from 'moment';
import ConfirmModal from '../../components/modals/ConfirmModal';
import useBarcodeScanner from '../../hooks/useBarcodeScanner';
import Split from 'react-split';
import TableEmpty from '../../components/common/TableEmpty';

const Block = styled.div`
  .close-left {
    transform: translate(-41.8%);
  }

  .table-inside {
    width: 100%;

    th {
      background: ghostwhite;
    }
  }

  .img-preview {
    max-width: 150px;
  }
`;

interface IStudentSearchData {
  classCode: string | undefined;
  keyword: string;
  campusCode: string;
  page: number;
  pageSize: number;
  semesterType: string | undefined;
}

interface IAvailableBooksData {
  keyword: string;
  campusCode: string;
  page: number;
  pageSize: number;
}

const CheckoutBooks = () => {
  const { t, i18n } = useTranslation();
  const { currentCampus: campusCode } = useSelector(
    (state: RootState) => state.auth,
  );
  const { commonCodes } = useSelector((state: RootState) => state.commonCode);
  // PR0002 = 학기유형
  const PR0002 = commonCodes.find((item) => item.commonCode === 'PR0002')?.detailCode;
  const [page, setPage] = useState(0);
  const [availableBooksPage, setAvailableBooksPage] = useState(0);
  const [studentLoanHistoryPage, setStudentLoanHistoryPage] = useState(1);
  const [studentLoanHistoryPageSize] = useState(10);
  const [studentSelected, setStudentSelected] = useState<any>(null);
  const [selectedBooks, setSelectedBooks] = useState<any>([]);
  const [selectedBooksKeys, setSelectedBooksKeys] = useState<React.Key[]>([]);
  const [loanBooksSelected, setLoanBooksSelected] = useState<any>([]);
  const [loanBooksKeys, setLoanBooksKeys] = useState<React.Key[]>([]);
  const barcode = useBarcodeScanner();

  const [studentSearchData, setStudentSearchData] =
    useState<IStudentSearchData>({
      classCode: undefined,
      campusCode,
      keyword: '',
      page: 1,
      pageSize: 20,
      semesterType: undefined
    });
  const [availableBooksSearchData, setAvailableBooksSearchData] =
    useState<IAvailableBooksData>({
      campusCode,
      keyword: '',
      page: 1,
      pageSize: 10,
    });
  
  const { data: scClassList, execute: scClassExecute } = useAxios<IGetClasses>();
  const { data: rgClassList, execute: rgClassExecute } = useAxios<IGetClasses>();
  const { data: scSemesterData, execute: scSemesterExecute } = useAxios<IGetCurrentSemester>();
  const { data: rgSemesterData, execute: rgSemesterExecute } = useAxios<IGetCurrentSemester>();
  const [getStudentsTrigger, { data: studentsResponse }] = useLazyGetStudentByCampusClassQuery();

  const [
    getAvailableLoanableBooksTrigger,
    { data: availableLoanableBooksResponse },
  ] = useLazyGetAvailableLoanableBooksQuery();
  const [getStudentLoanTrigger, { data: studentLoanResponseData }] =
    useLazyGetStudentBookLoanHistoryQuery();
  const [booksLoanTrigger, { isSuccess: isLoanSuccess }] =
    useSaveBookLoanMutation();
  const [booksCancelLoanTrigger, { isSuccess: isCancelLoanSuccess }] =
    useCancelBookLoanMutation();
  const [isLoanCheckDuplicateTrigger] = useLazyGetBookLoanDuplicateQuery();
  const [isDuplicateVisible, setIsDuplicateVisible] = useState<boolean>(false);
  const [isDuplicateBookNames, setIsDuplicateBookNames] = useState([]);
  /** 중복 대출 조회 API 응답 전까지 대출 버튼 비활성화 */
  const [isDuplicateCheckPending, setIsDuplicateCheckPending] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const students = studentsResponse?.data;
  const availableLoanableBooks = availableLoanableBooksResponse?.data;
  const studentLoanData = studentLoanResponseData?.data;

  const [scCurrentSemester, setScCurrentSemester] = useState<ICurrentSemester>();
  const [rgCurrentSemester, setRgCurrentSemester] = useState<ICurrentSemester>();
  const [semesterType, setSemesterType] = useState('');
  const [classList, setClassList] = useState<IClassList[]>([]);

useEffect(() => {
    //semesterExecute(getCurrentSemester());
    scSemesterExecute(getCurrentSemesterByType('SC'));
    rgSemesterExecute(getCurrentSemesterByType('RG'));
  }, []);

  useEffect(() => {
    if(scSemesterData) {
      setScCurrentSemester(scSemesterData?.data);
    }
  }, [scSemesterData]);

  useEffect(() => {
    setRgCurrentSemester(rgSemesterData?.data);
  }, [rgSemesterData]);

  useEffect(() => {
    const tempClassList: IClassList[] = [];

    if(rgClassList) {
      tempClassList.push(...rgClassList.data)
    }

    if(scClassList) {
      tempClassList.push(...scClassList.data)
    }

    setClassList(tempClassList);
  }, [scClassList, rgClassList]);

  useEffect(() => {
    if (!campusCode || !rgCurrentSemester?.semesterCode) return;

    rgClassExecute(getClasses(campusCode, rgCurrentSemester!.semesterCode));
  }, [campusCode, rgCurrentSemester]);

  useEffect(() => {
    if (!campusCode || !scCurrentSemester?.semesterCode) return;

    scClassExecute(getClasses(campusCode, scCurrentSemester!.semesterCode));
  }, [campusCode, scCurrentSemester]);

  useEffect(() => {
    if (!campusCode) return;

    setStudentSearchData({
      ...studentSearchData,
      classCode: undefined,
      campusCode,
    });
    setAvailableBooksSearchData({ ...availableBooksSearchData, campusCode });
  }, [campusCode]);

  useEffect(() => {
    if (!page) return;

    setStudentSearchData({ ...studentSearchData, page });
    getStudentsTrigger({ ...studentSearchData, page, semesterType: semesterType || undefined });
  }, [page]);

  useEffect(() => {
    if (!availableBooksPage) return;

    setAvailableBooksSearchData({
      ...availableBooksSearchData,
      page: availableBooksPage,
    });
    getAvailableLoanableBooksTrigger({
      ...availableBooksSearchData,
      page: availableBooksPage,
    });
  }, [availableBooksPage]);

  useEffect(() => {
    if (!studentLoanHistoryPage) return;

    getStudentLoanTrigger({
      ...studentSelected,
      campusCode,
      page: studentLoanHistoryPage,
      pageSize: 10,
      studentMemberCode: studentSelected?.memberCode,
    });
  }, [studentLoanHistoryPage]);

  useEffect(() => {
    if (!isLoanSuccess) return;

    enqueueSnackbar(t('booksManagement.books.message8'), successVariant);
    setSelectedBooks([]);
    setSelectedBooksKeys([]);
    setIsDuplicateVisible(false);
  }, [isLoanSuccess]);

  useEffect(() => {
    if (!isCancelLoanSuccess) return;

    enqueueSnackbar(t('booksManagement.books.message9'), successVariant);
    setLoanBooksSelected([]);
    setLoanBooksKeys([]);
  }, [isCancelLoanSuccess]);

  useEffect(() => {
    if (barcode != null) {
      setAvailableBooksSearchData({
        ...availableBooksSearchData,
        keyword: barcode,
      });
      getAvailableLoanableBooksTrigger({
        ...availableBooksSearchData,
        keyword: barcode,
        page: 1,
      });
      setAvailableBooksPage(1);
      setSelectedBooks([]);
    }
  }, [barcode]);

  useEffect(() => {
    if (!availableBooksSearchData?.page) return;

    setSelectedBooks([]);
    setSelectedBooksKeys([]);
  }, [availableBooksSearchData?.page]);

  const studentColumns: TableColumnsType<object> = [
    {
      title: t('booksManagement.books.column1'),
      dataIndex: 'no',
      align: 'center',
      width: '10%',
    },
    {
      title: t('booksManagement.books.column14'),
      dataIndex: 'studentName',
      align: 'center',
      ellipsis: true,
    },
    {
      title: t('booksManagement.books.column15'),
      dataIndex: 'memberCode',
      align: 'center',
      width: '15%',
      ellipsis: true,
    },
    {
      title: t('booksManagement.books.column16'),
      dataIndex: 'studentStatusCode',
      align: 'center',
      width: '10%',
      render: (value: string) =>
        getCommonCodeLabel('MB0003', value, i18n.language),
    },
    {
      title: t('booksManagement.books.column17'),
      dataIndex: 'className',
      align: 'center',
      width: '20%',
      ellipsis: true,
    },
  ];

  // TODO: 대출 할 수 있는 캠퍼스 복본들
  const duplicateColumns: TableColumnsType<object> = [
    {
      title: t('booksManagement.books.column1'),
      dataIndex: 'no',
      align: 'center',
      ellipsis: true,
      width: '6%',
    },
    {
      title: t('booksManagement.books.column2'),
      dataIndex: 'bookName',
      align: 'center',
      ellipsis: true,
      render: value => <div className='text-left ant-table-cell-ellipsis'>{value}</div>
    },
    {
      title: t('booksManagement.books.column4'),
      dataIndex: 'isbn',
      align: 'center',
      ellipsis: true,
      width: '20%',
    },
    {
      title: t('booksManagement.books.column19'),
      dataIndex: 'bookSeq',
      align: 'center',
      width: 100,
    },
    {
      title: t('booksManagement.books.column31'),
      dataIndex: 'bookStatus',
      align: 'center',
      ellipsis: true,
      width: '10%',
      render: (value: string) =>
        getCommonCodeLabel('BK0002', value, i18n.language),
    },
  ];
  const loanedBooksListColumns: TableColumnsType<object> = [
    {
      title: t('booksManagement.books.column1'),
      dataIndex: 'no',
      align: 'center',
      width: 80,
    },
    {
      title: t('booksManagement.books.column2'),
      dataIndex: 'bookName',
      align: 'center',
      ellipsis: true,
      render: value => <div className="text-left ant-table-cell-ellipsis">{value}</div>,
    },
    {
      title: t('booksManagement.books.column19'),
      dataIndex: 'bookSeq',
      align: 'center',
      width: '10%',
    },
    {
      title: t('booksManagement.books.column20'),
      dataIndex: 'lendingDate',
      align: 'center',
      width: '10%',
      render: (value) => {
        return moment(value).format('YYYY-MM-DD');
      },
    },
    {
      title: t('booksManagement.books.column21'),
      dataIndex: 'returnPlanDate',
      align: 'center',
      width: '20%',
      render: (value, record: any) => {
        return record?.overdueDay ? (
          <>
            {moment(record?.returnPlanDate).format('YYYY-MM-DD')}
            <span style={{ color: 'red' }}>
              ({record?.overdueDay}
              {t('booksManagement.books.column22')})
            </span>
          </>
        ) : (
          moment(value).format('YYYY-MM-DD')
        );
      },
    },
  ];

  const rowSelection = {
    selectedRowKeys: selectedBooksKeys,
    onChange: (selectedRowKeys: React.Key[], selectedRows: any) => {
      setSelectedBooks(selectedRows);
      setSelectedBooksKeys(selectedRowKeys);
    },
    getCheckboxProps: (record: any) => ({
      disabled: record.bookStatus === 'IN',
    }),
  };

  const studentLoanRowSelection = {
    selectedRowKeys: loanBooksKeys,
    onChange: (selectedRowKeys: React.Key[], selectedRows: any) => {
      setLoanBooksSelected(selectedRows);
      setLoanBooksKeys(selectedRowKeys);
    },
    getCheckboxProps: (record: any) => ({
      disabled:
        moment.duration(moment().diff(moment(record.lendingDate))).asDays() >=
        1,
    }),
  };

  return (
    <>
      <SimpleHeader
        iconFile="icon-student-big.svg"
        parentMenu={t('common.menu.book')}
        currentMenu={t('booksManagement.books.column35')}
        onlyTitle={true}
      />
      <Block className="content">
        <Split
          className="splite-divide"
          sizes={[45, 55]}
          minSize={100}
          expandToMin={false}
          gutterSize={10}
          gutterAlign="center"
          snapOffset={30}
          dragInterval={1}
          direction="horizontal"
          cursor="col-resize"
        >
          {/* Left Side */}
          <div className="col-frame left_panel">
            <div className="common-search mt-5">
              <div className="search-area mt-3">
                <ul className="search-bx">
                  <li>
                    <label>{t('common.menu.campus')}</label>
                    <div>
                      <SelectCampus />
                    </div>
                  </li>
                  <li>
                      <label>
                        {t('program.semester.column11')}
                      </label>
                      <Select
                        className="w-120p"
                        value={semesterType}
                        onChange={value => setSemesterType(value)}
                      >
                        <Select.Option key={'all'} value={''}>
                          {t('common.text.all')}
                        </Select.Option>
                        {
                          PR0002?.map(({korName: label, detailCode: value}) => {
                            return (
                              <Select.Option key={value} value={value}>
                                {label}
                              </Select.Option>
                            )
                          })
                        }
                      </Select>
                    </li>  
                  <li>
                    <label>{t('common.menu.class')}</label>
                    <div>
                      <Select
                        placeholder={t('common.menu.class')}
                        value={studentSearchData?.classCode}
                        onChange={(value) =>
                          setStudentSearchData({
                            ...studentSearchData,
                            classCode: value,
                          })
                        }
                        getPopupContainer={node => {
                          if (node) {
                            return node.parentNode as HTMLElement;
                          }
                          return document.body as HTMLElement;
                        }}
                      >
                        {classList?.filter((si: any) => semesterType === '' || semesterType === si.semesterType).map((item: any) => {
                          return (
                            <Select.Option
                              key={item.classCode}
                              value={item.classCode}
                              className="expenseAccount1"
                            >
                              {item.className}
                            </Select.Option>
                          );
                        })}
                      </Select>
                    </div>
                  </li>
                  <li>
                    <label>{t('booksManagement.books.column26')}</label>
                    <div className="w-10p">
                      <input
                        type="text"
                        placeholder={t('booksManagement.books.column26')}
                        className="form-control"
                        name="keyword"
                        onChange={(e) =>
                          setStudentSearchData({
                            ...studentSearchData,
                            [e.target.name]: e.target.value,
                          })
                        }
                        onKeyPress={(e) => {
                          if (e.key === 'Enter') {
                            if (!studentSearchData?.classCode) return;

                            getStudentsTrigger({
                              ...studentSearchData,
                              page: 1,
                              semesterType: semesterType || undefined
                            });
                            setPage(1);
                          }
                        }}
                      />
                    </div>
                    <div className='comm-btn__area'>
                      <Button
                        className="btn-basic small black"
                        disabled={!studentSearchData?.classCode}
                        onClick={() => {
                          getStudentsTrigger({ ...studentSearchData, page: 1, semesterType: semesterType || undefined });
                          setPage(1);
                        }}
                        text={t('common.button.search')}
                      />
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div>
              <div className="">
                <div className="comm-bx__between">
                  <div className="comm-sch_result">
                    {t('common.text.count')}: <b>{students?.totalCount ?? 0}</b>{t('books.text.6')}
                  </div>
                </div>
                
                <div className='comm-table__area'>
                  {!students?.classStudentsResponseDtos ? (
                    <>
                      <TableEmpty text={t('shuttle.text.40')} />
                    </>
                  ) : (
                    <Table
                      columns={studentColumns}
                      dataSource={students?.classStudentsResponseDtos ?? []}
                      sticky={true}
                      rowKey={(record: any) => record?.memberCode}
                      pagination={{
                        current: studentSearchData?.page,
                        pageSize: studentSearchData?.pageSize,
                      }}
                      onRow={(record: any) => {
                        return {
                          onClick: () => {
                            setStudentSelected(record);
                            setLoanBooksKeys([]);
                            setLoanBooksSelected([]);
                            setStudentLoanHistoryPage(1);
                            getStudentLoanTrigger({
                              ...record,
                              campusCode,
                              page: 1,
                              pageSize: 10,
                              studentMemberCode: record?.memberCode,
                            });
                          },
                        };
                      }}
                      rowClassName={(record: any) =>
                        record.memberCode === studentSelected?.memberCode
                          ? 'chosen'
                          : 'pointer'
                      }
                    />
                  )}
                </div>
                <div className="comm-bx__between">
                  <div className="common-paging right">
                    <Pagination
                      count={students?.totalCount ?? 0}
                      page={studentSearchData?.page}
                      perPage={studentSearchData?.pageSize}
                      param={studentSearchData}
                      setPage={setPage}
                      small
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="common-search mt-3">
              <div className="search-area">
                <ul className="search-bx">
                  <li>
                    <label>{t('booksManagement.books.column25')}</label>
                    <div>
                      <input
                        type="text"
                        placeholder={t('booksManagement.books.column25')}
                        className="form-control"
                        name="keyword"
                        onChange={(e) =>
                          setAvailableBooksSearchData({
                            ...availableBooksSearchData,
                            [e.target.name]: e.target.value,
                          })
                        }
                        value={availableBooksSearchData?.keyword}
                        onKeyPress={(e) => {
                          if (e.key === 'Enter') {
                            getAvailableLoanableBooksTrigger({
                              ...availableBooksSearchData,
                              page: 1,
                            });
                            setAvailableBooksPage(1);
                            setSelectedBooks([]);
                          }
                        }}
                      />
                    </div>
                    <div className='comm-btn__area'>
                      <Button
                        className="btn-basic small black"
                        onClick={() => {
                          if (!availableBooksSearchData?.keyword) {
                            enqueueSnackbar(
                              t('booksManagement.books.message14'),
                              infoVariant,
                            );
                            return;
                          }
                          setAvailableBooksPage(1);
                          setSelectedBooks([]);
                          getAvailableLoanableBooksTrigger({
                            ...availableBooksSearchData,
                            page: 1,
                          });
                        }}
                        text={t('common.button.search')}
                      />
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div>
              <div className="">
                <div className="comm-bx__between">
                  <div className="comm-sch_result">
                    {t('common.text.count')}:{' '}
                    <b>{availableLoanableBooksResponse?.data?.totalCount ?? 0}</b>{t('books.text.6')}
                  </div>
                </div>
                <div className='comm-table__area'>
                  {!availableLoanableBooks?.availableLoanableBookDtos ? (
                    <>
                      <TableEmpty text={t('shuttle.text.40')} />
                    </>
                  ) : (
                    <Table
                      columns={duplicateColumns}
                      dataSource={
                        availableLoanableBooks.availableLoanableBookDtos ?? []
                      }
                      sticky={true}
                      rowSelection={{
                        type: 'checkbox',
                        ...rowSelection,
                      }}
                      rowKey={(record: any) => record.clientBookNo}
                      pagination={{
                        current: availableBooksSearchData!.page,
                        pageSize: availableBooksSearchData!.pageSize,
                      }}
                    />
                  )}
                </div>
                <div className="comm-bx__between">
                  <div className="comm-btn__area">
                    {availableLoanableBooksResponse?.data?.totalCount > 0 && (
                      <Button
                        className="btn-basic pink"
                        disabled={isDuplicateCheckPending}
                        onClick={async () => {
                          if (!studentSelected) {
                            enqueueSnackbar(
                              t('books.text.14'),
                              infoVariant,
                            );
                            return;
                          }

                          if (selectedBooks.length <= 0) {
                            enqueueSnackbar(
                              t('books.text.15'),
                              infoVariant,
                            );
                            return;
                          }
                          // let newVar = await useGetBookLoanDuplicateQuery();

                          // console.log(newVar1);

                          setIsDuplicateCheckPending(true);
                          try {
                            const responseCheck = await isLoanCheckDuplicateTrigger(
                              {
                                studentMemberCode: studentSelected.memberCode,
                                copyBookInformationDtos: selectedBooks,
                              },
                            );

                            const responseData = responseCheck.data;
                            if (responseData?.data?.length) {
                              setIsDuplicateBookNames(
                                responseData?.data?.map((name: string) => {
                                  if (name.length > 8) {
                                    let replaceAll = name.replace(
                                      /^(.{1,8})(.*)$/,
                                      '$1...',
                                    );
                                    return replaceAll;
                                  }
                                  return name;
                                }),
                              );
                              setIsDuplicateVisible(true);
                              return;
                            }

                            booksLoanTrigger({
                              studentMemberCode: studentSelected.memberCode,
                              classCode: studentSelected.classCode,
                              campusCode,
                              copyBookInformationDtos: selectedBooks,
                            });
                          } finally {
                            setIsDuplicateCheckPending(false);
                          }
                        }}
                        text={t('books.text.16')}
                      />
                    )}
                  </div>
                  <div className="common-paging right">
                    <Pagination
                      count={
                        availableLoanableBooksResponse?.data?.totalCount ?? 0
                      }
                      page={availableBooksSearchData!.page}
                      perPage={availableBooksSearchData!.pageSize}
                      param={availableBooksSearchData}
                      setPage={setAvailableBooksPage}
                      small
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Right Side */}
          <div className="col-frame right_panel"> 
            <div className="comm-bx__between">
              <h3 className='sub-title'>{t('booksManagement.books.message10')}</h3>
            </div>
            <div className="comm-table__area">
              {!studentLoanData?.studentLoanHistoryDtos ||
              studentLoanData?.totalCount <= 0 ? (
                <TableEmpty text={t('booksManagement.books.message11')} />
              ) : (
                <Table
                  columns={loanedBooksListColumns}
                  dataSource={studentLoanData?.studentLoanHistoryDtos ?? []}
                  sticky={true}
                  rowSelection={{
                    type: 'checkbox',
                    ...studentLoanRowSelection,
                  }}
                  rowKey={(record: any) => record?.clientBookNo}
                  pagination={{
                    current: studentLoanHistoryPage,
                    pageSize: studentLoanHistoryPageSize,
                  }}
                />
              )}
            </div>
            <div className="comm-bx__between">
              <div className="comm-btn__area">
                {studentLoanData?.studentLoanHistoryDtos &&
                  studentLoanData?.totalCount > 0 && (
                    <>
                      <Button
                        className="btn-basic pink"
                        onClick={() => {
                          if (loanBooksSelected.length <= 0) {
                            enqueueSnackbar(
                              t('booksManagement.books.message12'),
                              infoVariant,
                            );
                            return;
                          }
                          booksCancelLoanTrigger(
                            loanBooksSelected.map((item: any) => {
                              return {
                                ...item,
                                cancel: true,
                              };
                            }),
                          );
                        }}
                        text={t('booksManagement.books.button4')}
                      />
                      <div className="flex align-items-center">{t('booksManagement.books.message13')}</div>
                    </>
                  )}
              </div>
              <div className="common-paging right">
                <Pagination
                  count={studentLoanData?.totalCount ?? 0}
                  page={studentLoanHistoryPage}
                  perPage={studentLoanHistoryPageSize}
                  setPage={setStudentLoanHistoryPage}
                  small
                />
              </div>
            </div>
          </div>
        </Split>
        <ConfirmModal
          visible={isDuplicateVisible}
          setVisible={setIsDuplicateVisible}
          onConfirm={() =>
            booksLoanTrigger({
              studentMemberCode: studentSelected.memberCode,
              classCode: studentSelected.classCode,
              campusCode,
              copyBookInformationDtos: selectedBooks,
            })
          }
          titleText={t('books.text.17')}
          messageText={`${t(`${t('books.text.18')} ${
            isDuplicateBookNames.length
          }${t('books.text.19')}
          [${isDuplicateBookNames?.join(', ')}]`)}
          ${t('books.text.20')}`}
          cancelText={t('common.button.cancel')}
          confirmText={t('books.text.16')}
        />
      </Block>
    </>
  );
};

export default CheckoutBooks;
